module.exports = __webpack_public_path__ + "img/bus_title_img_8.0f1b5d55.svg";